/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';

// TODO: simplify the state to only hold the current bio material (with its attachments)
/* Initial State */
const initialState = {
  currentBmAttachments: [], // attachments of the current bio material
  currentBioMaterialId: null,
};

/* Slice */
export const bioMaterialsSlice = createSlice({
  name: 'bioMaterials',
  initialState,
  reducers: {
    updateCurrentBmAttachments(state, action) {
      state.currentBmAttachments = action.payload;
    },
    updateCurrentBioMaterialId(state, action) {
      state.currentBioMaterialId = action.payload;
    },
  },
});

/* Selectors */
const selectBioMaterials = state => state[bioMaterialsSlice.name];
export const selectCurrentBioMaterialAttachments = createSelector(selectBioMaterials, s => s.currentBmAttachments);
export const selectCurrentBioMaterialId = createSelector(
  selectBioMaterials,
  ({ currentBioMaterialId }) => currentBioMaterialId,
);
/* Actions */
export const { updateCurrentBmAttachments, updateCurrentBioMaterialId } = bioMaterialsSlice.actions;
